export default "__VITE_ASSET__BjGec4kt__"